import axios from 'axios'
import router from '@/router/routers'
import { Notification, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import Config from '@/settings'

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.NODE_ENV === 'production' ? window.BaseUrl.VUE_APP_BASE_API : '/', // api 的 base_url
  baseURL: '/',//window.BaseUrl.VUE_APP_BASE_API,
  timeout: Config.timeout // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers['X-Source-Type'] = 1;
    if (getToken()) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    if (undefined === config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }
    return config
  },
  error => {
    // Do something with request error
    console.log('error=>', error) // for debug
    return Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    // console.log('response -----> ', window.BaseUrl.VUE_APP_BASE_API)

    const code = response.status
    if (code < 200 || code > 300) {
      // Notification.error({
      //   title: '错误',
      //   message: response.message
      // })
      return Promise.reject('error')
    } else {
      const res = response.data
      if (res.code === 600 || res.code === 601 || res.code === 602) {
        MessageBox.confirm(
          '登录状态已过期，请重新登录',
          '系统提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return response.data
    }
  },
  error => {
    let code = 0
    try {
      code = error.response.data.status
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        // Notification.error({
        //   title: '网络请求超时',
        //   duration: 5000
        // })
        return Promise.reject(error)
      }
    }
    if (code) {
      if (code === 401) {
        MessageBox.confirm(
          '登录状态已过期，您可以继续留在该页面，或者重新登录',
          '系统提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      } else if (code === 403) {
        router.push({ path: '/401' })
      } else {
        let errorMsg = error.response.data.message
        if (errorMsg === undefined || errorMsg === '') {
          errorMsg = error.response.data.error
        }
        // Notification.error({
        //   title: '服务错误',
        //   message: errorMsg,
        //   duration: 5000
        // })
        // Notification.error({
        //   title: '网络请求超时',
        //   duration: 5000
        // })
      }
    } else {
      // Notification.error({
      //   title: '接口请求失败',
      //   duration: 5000
      // })
      // Notification.error({
      //   title: '网络请求超时',
      //   duration: 5000
      // })
    }
    return Promise.reject(error)
  }
)
export default service
